export default "__VITE_ASSET__DLan$ubh__"